// @ts-nocheck
// Development-only logger utility
// Prevents sensitive data from being logged in production

const isDevelopment = import.meta.env.DEV;

export const logger = {
  // Debug logs - only in development
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  // Info logs - only in development
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  // Warning logs - only in development
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  // Errors - always logged but sanitized in production
  error: (...args) => {
    if (isDevelopment) {
      // Full error details in development
      console.error(...args);
    } else {
      // Generic error message in production (no sensitive data)
      console.error('An error occurred. Please contact support if the issue persists.');
    }
  },

  // Development-only group for organized logging
  group: (label) => {
    if (isDevelopment) {
      console.group(label);
    }
  },

  groupEnd: () => {
    if (isDevelopment) {
      console.groupEnd();
    }
  },
};

export default logger;
